import React from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { useToast } from '../../contexts/ToastContext'
import AccountSettingsFields from '../../components/account/AccountSettingsFields'

const AccountSettingsPage: React.FC = () => {
  const { user, refreshUser } = useAuth()
  const { showToast } = useToast()

  if (!user) return null

  return (
    <div>
      <h1 className="text-2xl text-ink mb-1">Kontoindstillinger</h1>
      <p className="text-sm text-ink-500 mb-6">
        Opdater dit visningsnavn, e-mail og adgangskode. Organisation tildeles af en administrator.
      </p>

      <AccountSettingsFields
        name={user.name}
        email={user.email}
        organizationName={user.organization.name}
        onNameSaved={async () => {
          await refreshUser()
          showToast('Navn opdateret.')
        }}
        onEmailSaved={async () => {
          await refreshUser()
          showToast('E-mail opdateret.')
        }}
        onPasswordSaved={() => showToast('Adgangskode opdateret.')}
      />
    </div>
  )
}

export default AccountSettingsPage
